import { addClass, removeClass } from '@utils/domUtils';

/* global jQuery */

export default class UpdateApplicationStatusModal {
  static selectorString() {
    return '.UpdateApplicationStatusModal';
  }

  render(node, props) {
    this.subjectInput = node.querySelector('[name="subject"]');
    this.messageInput = node.querySelector('[name="message"]');
    this.messageInputWysiwyg = node.querySelector('.message .Wysiwyg');

    this.selectedSubject = this.subjectInput.value;
    this.selectedTemplate = this.messageInput.value;
    this.lockAutoReplace = false;
    this.ignoreInputChangeEvents = false;

    this.subjectInput.addEventListener('keyup', this.changedEmailSubject.bind(this));
    this.messageInput.addEventListener('keyup', this.changedEmailMessage.bind(this));
    this.messageInputWysiwyg.addEventListener('keyup', this.changedEmailMessage.bind(this));

    [...node.querySelectorAll('.send-mail-radio')].forEach(radio => {
      radio.addEventListener('change', evt => {
        this.toggleSendMailVisibility(evt.currentTarget.value);
      });
    });

    node.querySelector('[name="template"]').addEventListener('change', evt => {
      const templateId = evt.currentTarget.value;
      const templateDataNode = node.querySelector(
        `.template-values [data-template-id="${templateId}"]`,
      );

      if (!templateDataNode) {
        return;
      }

      const subject = templateDataNode ? templateDataNode.querySelector('.template-subject') : null;
      const template = templateDataNode
        ? templateDataNode.querySelector('.template-template')
        : null;

      this.selectedSubject = subject ? jQuery.trim(subject.innerHTML) : '';
      this.selectedTemplate = template ? jQuery.trim(template.innerHTML) : '';

      this.ignoreInputChangeEvents = true;

      this.subjectInput.value = this.selectedSubject;
      this.messageInputWysiwyg.editor.setData(this.selectedTemplate);

      this.lockAutoReplace = false;
      this.ignoreInputChangeEvents = false;

      this.updateTemplateTexts();
    });

    // NOTE: reset form on modal closed
    jQuery(node).on('hidden.bs.modal', () => {
      node.querySelector('form').reset();
      const sendMail = jQuery(node).find('.send-mail-radio').val();
      this.toggleSendMailVisibility(sendMail);

      const editor = this.messageInputWysiwyg.editor;
      editor.setData(this.messageInput.defaultValue);
    });

    this.interviewDate = node.querySelector('[name="interviewDate"]');
    if (this.interviewDate) {
      jQuery(this.interviewDate).bind('change', this.changedInterviewDate.bind(this));
    }
    this.interviewStartTime = node.querySelector('[name="interviewStartTime"]');
    if (this.interviewStartTime) {
      jQuery(this.interviewStartTime).bind('change', this.changedInterviewStartTime.bind(this));
    }
    this.interviewEndTime = node.querySelector('[name="interviewEndTime"]');
    if (this.interviewEndTime) {
      jQuery(this.interviewEndTime).bind('change', this.changedInterviewEndTime.bind(this));
    }

    // TODO: implement upload reset...
  }

  toggleSendMailVisibility(sendMail) {
    if (sendMail === 'no') {
      addClass(this.node.querySelector('.message-template'), 'hide');
      addClass(this.node.querySelector('.save-and-send-button'), 'hide');
      removeClass(this.node.querySelector('.save-button'), 'hide');
    } else if (sendMail === 'yes') {
      removeClass(this.node.querySelector('.message-template'), 'hide');
      removeClass(this.node.querySelector('.save-and-send-button'), 'hide');
      addClass(this.node.querySelector('.save-button'), 'hide');
    }
  }

  changedEmailSubject() {
    if (this.ignoreInputChangeEvents) {
      return;
    }

    this.lockAutoReplace = true;
  }

  changedEmailMessage() {
    if (this.ignoreInputChangeEvents) {
      return;
    }

    this.lockAutoReplace = true;
  }

  changedInterviewDate() {
    this.updateTemplateTexts();
  }

  changedInterviewStartTime() {
    this.updateTemplateTexts();
  }

  changedInterviewEndTime() {
    this.updateTemplateTexts();
  }

  updateTemplateTexts() {
    if (this.lockAutoReplace) {
      return;
    }

    const interviewDateValue = this.interviewDate ? this.interviewDate.value : '';
    const interviewStartTimeValue = this.interviewStartTime ? this.interviewStartTime.value : '';
    const interviewEndTimeValue = this.interviewEndTime ? this.interviewEndTime.value : '';

    const subject = this.selectedSubject
      .replace(/\[Interview Datum\]/g, interviewDateValue)
      .replace(/\[Interview Start\]/g, interviewStartTimeValue)
      .replace(/\[Interview Ende\]/g, interviewEndTimeValue);

    const message = this.selectedTemplate
      .replace(/\[Interview Datum\]/g, interviewDateValue)
      .replace(/\[Interview Start\]/g, interviewStartTimeValue)
      .replace(/\[Interview Ende\]/g, interviewEndTimeValue);

    this.ignoreInputChangeEvents = true;

    this.subjectInput.value = subject;

    if (this.messageInputWysiwyg.editor) {
      this.messageInputWysiwyg.editor.setData(message);
    }

    this.ignoreInputChangeEvents = false;
  }
}
